export enum EntityStoreKey {
  applications = 'applications',
}
